// Drupal returns /stockchart?...; some historical callers use ticker&params.
// Resolve both at this boundary so selection and prefetch use the same symbol.
export function resolveLegacyChartUrl(value, base) {
  if (typeof value !== 'string' || !value) return '';
  const origin = new URL(base, window.location.href).origin;
  let url;
  try {
    if (/^(https?:\/\/|\/\/|\/|stockchart\?)/i.test(value)) {
      url = new URL(value, origin + '/');
    } else if (value[0] === '?' || /^s=/.test(value)) {
      url = new URL('/stockchart' + (value[0] === '?' ? value : '?' + value), origin);
    } else {
      url = new URL('/stockchart?s=' + value, origin);
    }
  } catch (_) { return ''; }
  if (url.origin !== origin || url.pathname !== '/stockchart') return '';
  // Match PHP's last-value semantics without leaving duplicate keys for JS.
  const query = new URLSearchParams();
  url.searchParams.forEach((value, key) => query.set(key, value));
  if (!query.has('t')) query.set('t', '23');
  url.search = query.toString();
  return url.href;
}
